<template>
  <div class="order-details">
    <div class="order-details__heading">
      Products
    </div>
    <base-table :items="sopLines"
                :fields="fields">
    </base-table>
  </div>
</template>

<script>
import { BaseTable } from "spiritweb.packages.web-account";
import { EcommerceModule } from "spiritweb.packages.ecommerce";

export default {
  name: "OrderDetails",
  components: {
    BaseTable,
  },
  props: {
    sopLines: {
      type: Array,
      default: null,
    },
  },
  data () {
    return {
      fields: [
        {
          key: "productDisplayName",
          label: "Item",
        },
        {
          key: "quantity",
          label: "Quantity",
        },
        {
          key: "priceExcVat",
          label: "Cost Exc VAT",
          renderer: this.formatPrice,
        },
        {
          key: "priceIncVat",
          label: "Cost Inc VAT",
          renderer: this.formatPrice,
        },
      ],
    };
  },
  methods: {
    formatPrice ( input ) {
      return EcommerceModule.renderPrice( input, "gbp", "en-gb" );
    },
  },
};
</script>

<style lang="less" scoped>
.order-details {
  padding: 10px;

  &__heading {
    font-weight: 500;
    font-size: 1.13rem;
    margin-bottom: 10px;
    margin-left: 10px;
  }
}

/deep/ .base-table__heading-container {
  display: none;
}

</style>
